import { Component } from 'react'

export class Pagination extends Component {

	constructor( props ) {
		super( props )

		this.state = {
			range: this.getRange( +this.props.currentPage, +this.props.totalPages ),
		}

		this.setCurrentPage = this.setCurrentPage.bind( this )
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.currentPage !== this.props.currentPage || prevProps.totalPages !== this.props.totalPages ) {
			this.setState({ range: this.getRange( +this.props.currentPage, +this.props.totalPages ) })
		}
	}

	/**
	 * Get an array of the pages (made up of numbers and ellipses)
	 * 
	 * @param  {number} currentPage
	 * @param  {number} totalPages  
	 * @return {array}              Array of "page" objects { text, value } used to build out options for paginating.
	 */
	getRange( currentPage, totalPages ) {
		var delta = 2,
			left = currentPage - delta,
			right = currentPage + delta + 1,
			range = [],
			rangeWithDots = [],
			lastNum;

		// Build out number range array.
		for ( let i = 1; i <= totalPages; i++ ) {
			if ( i == 1 || i == totalPages || i >= left && i < right ) {
				range.push( i );
			}
		}

		for ( let i of range ) {

			// If this isn't the first run of the loop
			if ( lastNum ) {
				/**
				 * If 2 is the exact distance between the the prev and current number, just push the number
				 * If its > 2, add an elipses
				 */
				if ( 2 === i - lastNum ) {
					rangeWithDots.push({
						text: lastNum + 1,
						value: lastNum + 1,
					});
				} else if ( 1 !== i - lastNum ) {
					let value = lastNum < currentPage ? i - delta : lastNum + delta

					rangeWithDots.push({
						text: '...',
						value: value
					})
				}
			}

			// Push the current number.
			rangeWithDots.push({
				text: i,
				value: i
			})

			lastNum = i
		}

		return rangeWithDots;
	}

	setCurrentPage( page ) {
		this.props.updateFilter( 'paged', page )
	}

	render() {
		if ( this.props.totalPages > 1 ) {

			let leftDisabled = 1 >= this.props.currentPage
			let rightDisabled = this.props.totalPages === this.props.currentPage

			return (
				<ul className="pagination">
					<li className="pagination__item pagination__item--prev">
						<button 
							className="icon-chev-left pagination__link pagination__link--arrow"
							disabled={ leftDisabled }
							onClick={ () => this.setCurrentPage( this.props.currentPage - 1 ) }
						></button>
					</li>

					{this.state.range.map( ( { text, value }, index ) => {
						let current = value === +this.props.currentPage
						let currentClass = current ? 'pagination__item--current' : ''

						return (
							<li 
								className={ `pagination__item ${currentClass}` } 
								onClick={ () => this.setCurrentPage( value ) }
								role="link"
								aria-current={ current }
								key={ index }
							>
								<button
									className="pagination__item-inner pagination__link pagination__link--number"
									>{ text }</button
								>
							</li>
						)
					})}

					<li className="pagination__item pagination__item--next">
						<button 
							className="icon-chev-right pagination__link pagination__link--arrow"
							disabled={ rightDisabled }
							onClick={ () => this.setCurrentPage( this.props.currentPage + 1 ) }
						></button>
					</li>
				</ul>
			)
		} else {
			return ''
		}
	}
}